/*****************************************************************************
 * UmanIT - Manage background color on edito pages
 *****************************************************************************/

let allImages = document.querySelectorAll("[data-element='edito-image']");
const lastImage = Array.from(allImages).pop();

if(lastImage) {
  const parent = lastImage.offsetParent;
  const section = parent.closest(".section-edito");
  const skinColor = "#f4f1ea";
  let transparentLimit;


  addBackgroundColor(section, skinColor, transparentLimit);
  window.addEventListener("resize", function () {
    addBackgroundColor(section, skinColor, transparentLimit);
  });
}

/**
 * Ajoute le style du background de fond
 *
 * return {void}
 */
function addBackgroundColor(section, skinColor, transparentLimit) {
  const top = lastImage.offsetTop;
  const imgContainer = lastImage.getBoundingClientRect();
  const imgHeight = imgContainer.height;
  const offset = imgHeight * 0.66;

  section.classList.add("color-bg");

  if (window.innerWidth > 576) {
    transparentLimit = top + offset;
  } else {
    transparentLimit = top;
  }
  section.style.backgroundImage = `linear-gradient(transparent ${transparentLimit}px, ${skinColor} 0)`;

}
